import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { FabricActionsActivity } from 'app/model/pipeline/fabric-actions.activity';
import { ApiIntegrationActivityAdapter } from './api-integration.activity.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FabricActionsActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        description: '*',
        type: '*',
        linkedServiceName: '*',
        policy: '*',
        dependsOn: '*',
        userProperties: '*',
        typeProperties: {
            serviceType: '*',
            itemType: '*',
            workspaceId: '*',
            itemId: '*',
            apiRequest: '*',
            apiParameters: '*'
        }
    }
})
export class FabricActionsActivityAdapter extends ApiIntegrationActivityAdapter {
    public override model(): IModel {
        return Metamodel.modelFor(FabricActionsActivity);
    }

    protected override _createActivity(name: string, description?: string): FabricActionsActivity {
        return FabricActionsActivity.MODEL.create<FabricActionsActivity>(name, description);
    }
}
